export function formUtils() {
  /**
   * Checks the fields of a payload object for validation errors.
   * @param {Object} payload - The payload object to be validated.
   * @returns {Array<string>} - An array containing the validation errors, if any.
   */
  const checkFields = (payload) => {
    const validations = {
      message: (value) => {
        if (!value) return "Please enter a message";
      },
    };

    const validationErrors = Object.entries(validations).reduce(
      (errors, [field, validationFn]) => {
        const error = validationFn(payload[field]);
        return error ? [...errors, error] : errors;
      },
      []
    );

    return validationErrors;
  };

  return { checkFields };
}
